import { toast } from "react-toastify";
import MapIcon from "@mui/icons-material/Map";
import { toastOptions } from "../../config/toast";
import { axios } from "../../utils/axios";
import { Button } from "react-bootstrap";
import { formatRangeString } from "../Recibos/handlers";

export const getReporteInspectores = async (setReporteInspectores, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().get("/get_reporte_inspectores");
  const { data, error } = result.data;
  if (data) {
    setReporteInspectores(data);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
};

export const getHistorialActasInspector = async (submittedData, setHistorialActasInspector, setHistorialCoordenadasInspector, setStr, setError, setIsLoading) => {
  let start = new Date(submittedData.fecha_ini);
  var end = new Date(submittedData.fecha_fin);
  if (start > end) {
    setError("fecha_ini", { type: "dateComparison", message: "La fecha de inicio no debe ser mayor que la fecha fin" });
    return;
  }

  setIsLoading(true);
  const result = await axios().post("/historial_inspector", submittedData);
  const { data, error } = result.data;

  if (data) {
    setHistorialActasInspector(data.actas);
    setHistorialCoordenadasInspector(data.coordenadas);
    setStr(formatRangeString(submittedData.fecha_ini, submittedData.fecha_fin) + ": " + data.actas.length);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
};

export const historialInspectoresTableData = (data, setSelectedRow, setModalIsOpen) => {
  const columns = [
    { field: "id", headerName: "# id", hide: true },
    { field: "nombre", headerName: "Nombre/ID", flex: 1 },
    { field: "cant", headerName: "Cantidad de actas generadas", flex: 2 },
    {
      field: "verMapaDeCalor",
      headerName: "Ver mapa de calor",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            {params.row.cant > 0 ? (
              <Button
                style={{ color: "#006BB1" }}
                onClick={() => {
                  setSelectedRow(params.row);
                  setModalIsOpen(true);
                }}
              >
                Ver mapa de calor
                <MapIcon className='ms-2 mb-1' />
              </Button>
            ) : (
              <p className='mb-0'>{params.row.nombre} no cargó actas</p>
            )}
          </>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      nombre: d.nombre === "Undefined property: stdClass::$data" ? d.id : d.nombre,
      cant: d.cant,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return String(d.id)?.toString().toLowerCase().includes(value) || String(d.nombre)?.toLowerCase().includes(value);
  };

  return { columns, rows, filter };
};
